import React from 'react';

const MediaPlayer = ({ audioUrl, videoUrl, type = 'audio' }) => {
  if (videoUrl) {
    return (
      <video 
        controls 
        style={{width: '100%', maxHeight: '300px', display: 'block', marginTop: '10px'}} 
        controlsList="nodownload"
      >
        <source src={videoUrl} type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>
    );
  }

  if (audioUrl) {
    return (
      <audio 
        controls 
        style={{width: '100%', display: 'block', marginTop: '10px'}} 
        controlsList="nodownload"
      >
        <source src={audioUrl} type="audio/mpeg" />
        <source src={audioUrl} type="audio/ogg" />
        Tu navegador no soporta el elemento de audio.
      </audio>
    );
  }

  return null;
};

export default MediaPlayer;